/* eslint-disable */
"use strict";

import { connect } from "mqtt";

// const service = process.env.VUE_APP_service_reparti || '' // usato solo per installazione su Windows 32bit (senza IIS con reverse proxy)
var config, service;
(async () => {
  const response = await fetch(process.env.BASE_URL + "config.json");
  config = await response.json();
  service = config.service_ristorazione
})();


async function verifyConnection(clientId) {
  if(clientId === '') return { connected: true }
  const url = `${service}/connectionstatus/${clientId}`;

  const response = await fetch(url);
  debugger
  const result =  await response.json();
  debugger
  return result
}

export default {
  verifyConnection,
};
